import type { HTMLAttributes, ReactNode } from 'react';
import { cn } from '@/lib/utils';

interface HeadingProps extends HTMLAttributes<HTMLHeadingElement> {
  children: ReactNode;
}

export function Heading1({ className, children, ...props }: HeadingProps) {
  return (
    <h1
      className={cn(
        'text-2xl font-semibold leading-tight tracking-tight text-text-primary',
        className
      )}
      {...props}
    >
      {children}
    </h1>
  );
}

export function Heading2({ className, children, ...props }: HeadingProps) {
  return (
    <h2
      className={cn(
        'text-xl font-semibold leading-tight tracking-tight text-text-primary',
        className
      )}
      {...props}
    >
      {children}
    </h2>
  );
}

export function Heading3({ className, children, ...props }: HeadingProps) {
  return (
    <h3
      className={cn(
        'text-base font-semibold leading-tight tracking-tight text-text-primary',
        className
      )}
      {...props}
    >
      {children}
    </h3>
  );
}
